//  Fichier : src/Experience/Preloader.js

// Importations
import EventEmitter from "./Utils/EventEmitter.js";

import { gsap } from "gsap";

export default class Preloader extends EventEmitter {
  constructor(experience) {
    super();

    this.experience = experience;
    this.resources = this.experience.resources;
    this.transition = this.experience.transition;

    // Éléments du DOM
    this.preloaderElement = document.querySelector("div.preloader");
    this.preloaderLogo =
      this.preloaderElement.querySelector(".preloader__logo");
    this.navLogo = document.querySelector(".nav__logo");
    this.clipRect = this.preloaderElement.querySelector(".clipRect");

    // Paramètres de l'animation
    this.params = {
      duration: 1.0,
      delay: 0,
    };

    this.getPositions();
    this.init();
  }

  getPositions() {
    // Position du logo dans la nav
    const logoRect = this.navLogo.getBoundingClientRect();
    const clipX = logoRect.left + logoRect.width / 2;
    const clipY = logoRect.top + logoRect.height / 2;

    // Position du logo dans le preloader
    const preloaderRect = this.preloaderLogo.getBoundingClientRect();
    const X = preloaderRect.left + preloaderRect.width / 2;
    const Y = preloaderRect.top + preloaderRect.height / 2;

    // Distance entre les deux
    this.deltaX = clipX - X;
    this.deltaY = clipY - Y;
  }

  init() {
    // Timeline de chargement
    this.tlLoad = gsap
      .timeline({ paused: true })
      .fromTo(this.clipRect, { attr: { y: "100%" } }, { attr: { y: "0%" } });

    // Timeline de révélation
    this.tlReveal = gsap
      .timeline({
        paused: true,
        defaults: { ...this.params },
      })
      // Logo grossit
      .to(this.preloaderLogo, {
        scale: 1.2,
        ease: "back.out",
        duration: this.params.duration * 0.25,
        onComplete: () => {},
      })
      .to(this.preloaderLogo, {
        scale: 1,
        ease: "power3.out",
        duration: this.params.duration * 0.5,
      })
      // Logo se déplace vers la nav
      .fromTo(
        this.preloaderLogo,
        { y: "0", x: "0" },
        {
          y: this.deltaY,
          x: this.deltaX,
          duration: this.params.duration * 0.85,
          ease: "power3.inOut",
        },
        "<"
      )
      // Logo disparait
      .to(this.preloaderLogo, {
        autoAlpha: 0,
        duration: 0,
      });
  }

  // Animation de la progression du chargement
  onloadAnimation(progress) {
    gsap.to(this.tlLoad, {
      progress: progress,
      duration: 1,
      ease: "power2.out",
      overwrite: "auto",
      onComplete: () => {
        if (progress === 1) {
          this.preloaderElement.classList.add("--loaded");
          this.tlReveal.play();

          this.trigger("completed");
        }
      },
    });
  }

  // Quand tout est prêt
  onReady() {}
}
